/**
 * Product Image Loader Fix
 * This script ensures that product images load properly on initial page load
 */

// Simple product image fix for desktop view
document.addEventListener('DOMContentLoaded', function() {
  // Only run this code on product pages
  if (!window.location.pathname.includes('/products/')) return;
  
  // Fix product images on desktop
  function fixProductImages() {
    // Target the specific product image containers
    const containers = document.querySelectorAll('.product-image-container, .img_thumb.js_prod_main, .img_thumb.js_prod_main2');
    
    containers.forEach(container => {
      // Remove height constraints
      container.style.height = 'auto';
      container.style.minHeight = '400px';
      container.style.maxHeight = 'none';
      container.style.overflow = 'visible';
      
      // Fix image wrappers
      const wrappers = container.querySelectorAll('.product-image-wrapper, .js-zoom-img, .zoom-image');
      wrappers.forEach(wrapper => {
        wrapper.style.height = 'auto';
        wrapper.style.overflow = 'visible';
      });
      
      // Fix images
      const images = container.querySelectorAll('img');
      images.forEach(img => {
        img.style.maxHeight = 'none';
      });
    });
  }
  
  // Run the fix immediately
  fixProductImages();
  
  // Run again after a short delay to catch any dynamically loaded elements
  setTimeout(fixProductImages, 500);
  setTimeout(fixProductImages, 1000);
});

function initProductImageFix() {
  console.log('Initializing product image fix...');
  
  // Target selectors for main product images
  const mainImageSelectors = [
    '.js_prod_main img', 
    '.js_prod_main2 img',
    '.img_thumb img',
    '.product-single__photos img',
    '.engoj-nav-item img',
    '.product-image-wrapper img',
    '.engoj_img_main'
  ];
  
  // Find all main product images
  let mainImages = [];
  mainImageSelectors.forEach(selector => {
    const images = document.querySelectorAll(selector);
    if (images.length) {
      mainImages = [...mainImages, ...images];
    }
  });
  
  if (!mainImages.length) {
    console.log('No product images found to fix');
    return;
  }
  
  console.log(`Found ${mainImages.length} product images to fix`);
  
  // Force immediate loading of all images
  mainImages.forEach(img => {
    // Replace lazy loading with direct loading
    if (img.hasAttribute('data-src')) {
      const src = img.getAttribute('data-src');
      img.setAttribute('src', src);
      img.removeAttribute('data-src');
    }
    
    // Remove lazyload and lazy classes
    img.classList.remove('lazyload', 'lazy');
    
    // Add loading=eager attribute
    img.setAttribute('loading', 'eager');
    
    // Force immediate visibility
    img.style.opacity = '1';
    img.style.visibility = 'visible';
    
    // Force image to reload
    if (img.complete) {
      // If already loaded, trigger a reload
      const currentSrc = img.getAttribute('src');
      if (currentSrc) {
        setTimeout(() => {
          img.setAttribute('src', currentSrc + '?t=' + new Date().getTime());
        }, 10);
      }
    }
    
    // Add event listeners to ensure image is visible when loaded
    img.addEventListener('load', function() {
      this.style.opacity = '1';
      this.style.visibility = 'visible';
      
      // Notify Slick slider that content dimensions may have changed
      if (typeof $.fn.slick !== 'undefined') {
        setTimeout(() => {
          try {
            $('.js_prod_main').slick('setPosition');
            $('.js_prod_main2').slick('setPosition');
            $('.js_prod_sub').slick('setPosition');
            $('.js_prod_sub2').slick('setPosition');
          } catch (e) {
            // Ignore errors if sliders aren't initialized
          }
        }, 100);
      }
    });
    
    // Special handling for the first/main image
    if (img.classList.contains('engoj_img_main') || 
        img.parentElement.classList.contains('js_prod_main') ||
        img.parentElement.classList.contains('js_prod_main2')) {
      img.setAttribute('importance', 'high');
    }
  });
  
  // Preload all product images to ensure they're in the browser cache
  preloadProductImages();
}

function preloadProductImages() {
  // Get all thumbnail images to preload their full-size versions
  const thumbnails = document.querySelectorAll('.product-thumbnail img, .js_prod_sub img, .js_prod_sub2 img');
  
  thumbnails.forEach(thumbnail => {
    const thumbSrc = thumbnail.getAttribute('data-src') || thumbnail.getAttribute('src');
    if (thumbSrc) {
      // Convert thumbnail URL to full-size URL
      const fullSizeUrl = thumbSrc.replace(/_60x60/g, '').replace(/_100x100/g, '');
      
      // Create a hidden image to preload
      const preloadImg = new Image();
      preloadImg.src = fullSizeUrl;
    }
  });
} 